import { useRef, useState, useEffect, useCallback } from "react";
import ShakaPlayer from "shaka-player-react";
import {
  getTLang,
  formatVideoTime,
  convertTimeStringsToSeconds,
} from "../../../utils/common";

import VideoMarkers from "../../shared/VideoMarkers";
import { useTranslation } from "react-i18next";

const Video = ({
  moduleContent,
  renderQuestionContent,
  userAnswers,
  setIsSubmit,
  setModuleContent,
  updateLmsModule,
  setCompleted,
  setIsVideoWatchComplete: setParentVideoWatchComplete,
}) => {
  const renderCount = useRef(0);
  renderCount.current++;
  const t = getTLang();
  const videoMarkings = [];
  const questionAppearCountMap = {};
  for (let i = 0; i <= moduleContent?.questions?.length; i++) {
    const question = moduleContent?.questions[i];
    if (question) {
      questionAppearCountMap[question?.qid] = 0;
      videoMarkings.push(question?.video_marking);
    }
  }

  const sortedMarkings = videoMarkings?.sort((a, b) => {
    const toSeconds = (timeStr) => {
      if (!timeStr || typeof timeStr !== "string") return 0;
      const parts = timeStr.split(":").map(Number);
      if (parts.length !== 2 || parts.some(isNaN)) return 0;
      const [min, sec] = parts;
      return min * 60 + sec;
    };

    return toSeconds(a) - toSeconds(b);
  });

  const timeStamps = convertTimeStringsToSeconds(videoMarkings);
  const controllerRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(true);
  const [shownQuestionTimeStamps, setShownQuestionTimeStamps] = useState([]);
  const [questionNumber, setQuestionNumber] = useState(0);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [currentMatchedQuestionIndex, setcurrentMatchedQuestionIndex] =
    useState(0);
  const [isVideoWatchComplete, setIsVideoWatchComplete] = useState(false); // [true,false]
  const [questionAppearCount, setQuestionAppearCount] = useState(
    questionAppearCountMap
  ); //[0,1,2]
  const [currentVideoTimeStamp, setCurrentVideoTime] = useState(null);
  let [showCloseBtn, setShowCloseBtn] = useState(false);
  let [showSubmitBtn, setShowSubmitBtn] = useState(true);
  // Add state to track if answers have been submitted for styling
  const [showAnswerFeedback, setShowAnswerFeedback] = useState(false);
   const { i18n } = useTranslation();
  const currentLang = localStorage.getItem('userLang')
  
    const getLangCode = (lang) => {
      switch (lang) {
        case 'English':
          return 'en'; 
        case 'Hindi':
          return 'hi';
        case 'Marathi':
          return 'mar';
        default:
          return 'en';
      }
    };
  
    const langId = getLangCode(currentLang);
    const tForLang = i18n.getFixedT(langId);

  const togglePlayPause = (e) => {
    const { videoElement } = controllerRef?.current;
    if (e) {
      e.preventDefault();
    }
    if (videoElement?.paused) {
      videoElement?.play();
    } else {
      videoElement?.pause();
    }
  };
  let [visibleQuestion, setVisibleQuestion] = useState({});
  const paragraphs = moduleContent?.transcript
    ? moduleContent?.transcript
      .split(/<\/p>/)
      .map((str) =>
        str
          .replace(/<p>/g, "")
          .replace(/&nbsp;|​/g, " ")
          .trim()
      )
      .filter((str) => str.length > 0)
    : null;
  const visibleQuestionId = visibleQuestion?.qid || null;

  const [currentSecond, setCurrentSecond] = useState(0);
  const [playbackTime, setPlaybackTime] = useState("00:00");
  const lastSecondRef = useRef(-1);
  let popupAnswerRef = useRef({});

  if (moduleContent.is_completed) {
    popupAnswerRef.current = userAnswers;
  }

  // Handle visibility change (tab switch, screen lock, etc.)
  const handleVisibilityChange = () => {
    const videoElement = controllerRef?.current?.videoElement;
    if (!videoElement) return;

    if (document.hidden || document.visibilityState === "hidden") {
      // Pause video when tab is not visible or screen is locked
      if (!videoElement.paused) {
        videoElement.pause();
        console.log("Video paused due to visibility change");
      }
    }
  };

  const handleClose = (e) => {
    setShowCloseBtn(!showCloseBtn);
    setShowSubmitBtn(!showSubmitBtn);
    setShowOverlay(false);
    // Reset answer feedback when closing overlay
    setShowAnswerFeedback(false);
    setQuestionAppearCount({
      ...questionAppearCount,
      [visibleQuestionId]: questionAppearCount[visibleQuestionId] + 1,
    });

    // Auto-resume video playback when closing overlay
    const videoElement = controllerRef?.current?.videoElement;
    if (videoElement && videoElement.paused) {
      videoElement.play();
    }
  };

  const handleNext = (e) => {
    if (e) {
      e.preventDefault();
    }
    userAnswers.forEach((element) => {
      if (element.qid === visibleQuestionId) {
        visibleQuestion = {
          ...visibleQuestion,
          ...{
            user_answer: element.user_answer,
          },
        };
        setVisibleQuestion(visibleQuestion);
        element.timeStamp = currentVideoTimeStamp.toString();
        element.qNumber = questionNumber;
      }
    });

    popupAnswerRef.current = userAnswers;

    // Enable answer feedback to show correct/incorrect styling
    setShowAnswerFeedback(true);
    setShowCloseBtn(true);
    setShowSubmitBtn(false);
    setShowOverlay(true);
  };

  const handleSubmitAccesiblity = useCallback(() => {
    if (moduleContent?.is_completed) {
      setShowCloseBtn(true);
      setShowSubmitBtn(false);
    } else {
      const isAnswered = userAnswers.some(
        (val) => val.qid === visibleQuestionId && val?.user_answer.length > 0
      );
      setIsSubmitDisabled(isAnswered ? false : true);
    }
  }, [moduleContent?.is_completed, userAnswers, visibleQuestionId]);

  const handleModuleSubmit = useCallback(() => {
    if (
      isVideoWatchComplete &&
      videoMarkings.length === popupAnswerRef?.current.length
    ) {
      console.log("in set is submit");
      setIsSubmit(false);
      setModuleContent((prev) => {
        return {
          ...prev,
          ...{ submit: true },
        };
      });
    }
    console.log(
      "🚀 ~ handleModuleSubmit ~   video markings,isvideocomplete,popupAnswerRef",
      videoMarkings.length,
      isVideoWatchComplete,
      popupAnswerRef?.current.length
    );
  }, [
    isVideoWatchComplete,
    videoMarkings.length,
    setIsSubmit,
    setModuleContent,
  ]);

  const cleanRequestBody = useCallback(() => {
    console.log(
      "🚀 ~ userAnswers.forEach ~ userAnswers: --- before",
      userAnswers
    );

    if (
      popupAnswerRef?.current.length === videoMarkings.length &&
      isVideoWatchComplete
    ) {
      userAnswers.forEach((element) => {
        delete element.timeStamp;
        delete element.qNumber;
      });
    }
    console.log(
      "🚀 ~ userAnswers.forEach ~ userAnswers: --- after",
      userAnswers
    );
  }, [userAnswers, videoMarkings.length, isVideoWatchComplete]);

  // Effect for handling video events and cleanup
  useEffect(() => {
    let isSeekingLocal = false;
    const videoElement = controllerRef?.current?.videoElement;
    if (!videoElement) return;

    // Disable fullscreen API
    
    if (videoElement && window.innerWidth > 991) {
      videoElement.requestFullscreen = undefined;
      videoElement.webkitRequestFullscreen = undefined;
      videoElement.mozRequestFullScreen = undefined;
      videoElement.msRequestFullscreen = undefined;

      // Hide fullscreen button with CSS
      const style = document.createElement('style');
      style.textContent = `
        .shaka-player-video::-webkit-media-controls-fullscreen-button,
        .shaka-player-video button[aria-label*="fullscreen"],
        .shaka-player-video button[aria-label*="Fullscreen"],
        .shaka-player-video [class*="fullscreen"],
        .shaka-player-video [data-shaka-ui-locales*="fullscreen"] {
          display: none !important;
        }
        video::-webkit-media-controls-fullscreen-button {
          display: none !important;
        }
      `;
      document.head.appendChild(style);

      // Prevent fullscreen events
      videoElement.addEventListener('dblclick', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      // Override fullscreen change events
      document.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement === videoElement) {
          document.exitFullscreen();
        }
      });
    }

    // Define handleVideoEvents inside the effect to avoid dependency issues
    const handleVideoEventsInternal = () => {
      if (isSeekingLocal) return;

      if (!videoElement) return;

      const currentTime = videoElement.currentTime;
      const currentSecondFloor = Math.floor(currentTime);
      const currentVideoTime = formatVideoTime(currentTime);

      if (currentSecondFloor !== lastSecondRef.current) {
        lastSecondRef.current = currentSecondFloor;
        setCurrentSecond(currentSecondFloor);
        const minutes = Math.floor(currentSecondFloor / 60);
        const seconds = currentSecondFloor % 60;
        setPlaybackTime(
          `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`
        );

        if (shownQuestionTimeStamps.includes(currentVideoTime)) {
          const matchedPopup = popupAnswerRef?.current.find((val) => {
            const isMatch = val.timeStamp === currentVideoTime;
            if (isMatch) {
              setQuestionNumber(val.qNumber);
            }
            return isMatch;
          });
          if (matchedPopup) {
            let matchedQuestion = moduleContent.questions.find(
              (q) => q.qid === matchedPopup.qid
            );

            if (matchedQuestion) {
              const popupAnswerVal = popupAnswerRef?.current.find(
                (val) => val.qid === matchedQuestion.qid
              );

              const questionWithAnswer = popupAnswerVal
                ? {
                  ...matchedQuestion,
                  user_answer: popupAnswerVal.user_answer,
                }
                : matchedQuestion;
              videoElement?.pause();
              setVisibleQuestion(questionWithAnswer);
              setShowAnswerFeedback(true);
              setShowCloseBtn(true);
              setShowSubmitBtn(false);
              setShowOverlay(true);
            }
          }
        }
      }

      if (shownQuestionTimeStamps.includes(currentVideoTime)) {
        return;
      }
      let matchedQuestionIndex = -1;

      moduleContent?.questions.forEach((question, key) => {
        if (
          question.video_marking === currentVideoTime &&
          !shownQuestionTimeStamps.includes(question.video_marking)
        ) {
          matchedQuestionIndex = key;
          shownQuestionTimeStamps.push(currentVideoTime);
          return;
        }
      });

      if (matchedQuestionIndex !== -1) {
        setQuestionNumber((prev) => prev + 1);
        setcurrentMatchedQuestionIndex(matchedQuestionIndex);
        setShownQuestionTimeStamps((prev) => [...prev, currentVideoTime]);
        const currentQuesion = moduleContent.questions[matchedQuestionIndex];
        setVisibleQuestion(currentQuesion);
        setCurrentVideoTime(currentVideoTime);
        setShowOverlay(true);
        videoElement?.pause();
      }
    };

    // Event handlers for play, pause, and ended
    const handlePlay = () => {
      setShowPlayButton(false);
    };

    const handlePause = () => {
      setShowPlayButton(true);
    };

    const handleEnded = () => {
      console.log("video ended");
      setIsVideoWatchComplete(true);
      // Also update parent component if prop is provided
      if (setParentVideoWatchComplete) {
        setParentVideoWatchComplete(true);
      }
      // setShownQuestionTimeStamps([]);
      // setQuestionNumber(0);
     // popupAnswerRef.current = [];
    
    //  if (isVideoWatchComplete && !moduleContent?.is_completed) {
    //   // Enable answer feedback to show correct/incorrect styling
    //   setShowAnswerFeedback(true);
    //   setShowCloseBtn(true);
    //   setShowSubmitBtn(false);
    //    }
      };

    const handleVisibilityChange = () => {
      const { videoElement } = controllerRef?.current;
      if (document.visibilityState === 'hidden') {
        setShowPlayButton(false);
        videoElement.pause();
      }
    };

    // Add event listeners
    videoElement.addEventListener("timeupdate", handleVideoEventsInternal);
    videoElement.addEventListener("play", handlePlay);
    videoElement.addEventListener("pause", handlePause);
    videoElement.addEventListener("ended", handleEnded);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("blur", handleVisibilityChange);
    window.addEventListener("pagehide", handleVisibilityChange);
    window.addEventListener("freeze", handleVisibilityChange);

    // Cleanup on unmount or when dependencies change
    return () => {
      if (videoElement) {
        videoElement.removeEventListener(
          "timeupdate",
          handleVideoEventsInternal
        );
        videoElement.removeEventListener("play", handlePlay);
        videoElement.removeEventListener("pause", handlePause);
        videoElement.removeEventListener("ended", handleEnded);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("blur", handleVisibilityChange);
      window.removeEventListener("pagehide", handleVisibilityChange);
      window.removeEventListener("freeze", handleVisibilityChange);
    };
  }, [
    moduleContent?.url,
    shownQuestionTimeStamps,
    moduleContent?.questions,
    setParentVideoWatchComplete,
  ]);

   // Effect to set initial answer feedback state based on video and module completion status
  // useEffect(() => {
  //   // If video is completed but module is not completed, enable answer feedback
  //   if (isVideoWatchComplete && !moduleContent?.is_completed) {
  //     setShowAnswerFeedback(true);
  //   } else if (moduleContent?.is_completed) {
  //     // If module is completed, disable answer feedback
  //     setShowAnswerFeedback(false);
  //   }
  // }, [isVideoWatchComplete, moduleContent?.is_completed]);

  // Effect for other state-dependent logic
  useEffect(() => {
    handleSubmitAccesiblity();
    handleModuleSubmit();
    cleanRequestBody();
  }, [
    showOverlay,
    userAnswers,
    isVideoWatchComplete,
    handleSubmitAccesiblity,
    handleModuleSubmit,
    cleanRequestBody,
  ]);

  console.log(
    "showCloseBtn, moduleContent.is_completed",
    showCloseBtn,
    moduleContent.is_completed
  );

  const handleMarkAsCompleted = async (data) => {
    updateLmsModule().then((data) => {});

    setCompleted(true);
  };

  return (
    <div style={{ minHeight: window.innerWidth < 991 ? "65vh" : "auto", height: "auto"}}>
      <div className={`video-container mb-3 ${showOverlay ? "pe-none" : ""}`}>
        <ShakaPlayer
          ref={controllerRef}
          controls
          disablePictureInPicture
          controlsList={`noplaybackrate nodownload ${window.innerWidth < 991 ? 'allowfullscreen' : 'nofullscreen'}`}
          disableRemotePlayback
          allowFullScreen={window.innerWidth < 991 ? true : false}
          webkitallowfullscreen={window.innerWidth < 991 ? true : false}
          mozallowfullscreen={window.innerWidth < 991 ? true : false}
          src={moduleContent?.url}
          //  onError={handleError}
          className="shaka-player-video"
        />

        <VideoMarkers timeStamps={timeStamps} controllerRef={controllerRef} />

        {console.log("renderCount.current", renderCount.current)}

        {console.log("marking", timeStamps)}

        {showPlayButton && (
          <button type="button" className="play-btn" onClick={togglePlayPause}>
            <img src="/images/videoPlay.svg" alt="playbtn" />
          </button>
        )}

        {showOverlay && (
          <div className="video-overlay">
            <div key={visibleQuestion._id} className="d-flex flex-column justify-content-between w-100 px-4 pt-4" style={{ height: "100%" }}>
              <div>
                <h6 className="text-black mb-4 font-18 fw-bold border-bottom pb-3">Time to check what you have learned</h6>
                {renderQuestionContent(
                  visibleQuestion,
                  questionNumber,
                  moduleContent?.passing_percent,
                  moduleContent?.questions?.length || 0,
                  moduleContent?.is_completed,
                  moduleContent?.is_started,
                  moduleContent?.course_test_type,
                  false, // showCorrectAns
                  showAnswerFeedback // showVideoAnswerFeedback for video questions
                )}
              </div>
              <div>
                <hr className="border-top border-dark" />
                <div className="text-end pt-1 pb-3">
                  {showSubmitBtn && (
                    <button
                      type="button"
                      className="btn btn-md btn-primary rounded-pill mb-1"
                      disabled={isSubmitDisabled}
                      onClick={handleNext}
                    >
                      {tForLang("course_modules_submit")}
                    </button>
                  )}
                  {showCloseBtn && (
                    <button
                      type="button"
                      className="btn btn-md btn-primary rounded-pill mb-1"
                      onClick={handleClose}
                    >
                      {tForLang("course_modules_close")}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

      </div>{" "}
      {/* {showOverlay && (
        <div className="  video-overlay " style={{}}>
          <div key={visibleQuestion._id} className=" w-100 p-4" style={{ height: "400px", overflowY: "scroll" }}>
            <h6 className="text-black mb-4 font-18 fw-bold">Time to check what you have learned</h6>
            {renderQuestionContent(
              visibleQuestion,
              questionNumber,
              moduleContent?.passing_percent,
              moduleContent?.questions?.length || 0,
              moduleContent?.is_completed,
              moduleContent?.is_started,
              moduleContent?.course_test_type,
              false, // showCorrectAns
              showAnswerFeedback // showVideoAnswerFeedback for video questions
            )}
            <hr className="border-top border-dark" />

            <div className=" text-end pt-3">
              {showSubmitBtn && (
                <button
                  type="button"
                  className="btn btn-md btn-primary rounded-pill mb-2"
                  disabled={isSubmitDisabled}
                  onClick={handleNext}
                >
                    {tForLang("course_modules_submit")}
                </button>
              )}
              {showCloseBtn && (
                <button
                  type="button"
                  className="btn btn-md btn-primary rounded-pill mb-2"
                  onClick={handleClose}
                >
                  {tForLang("course_modules_close")}
                </button>
              )}
            </div>
          </div>
        </div>

      )} */}

      {paragraphs !== null && (
        <div className="row mt-4">
          <div className="col-md-12 ms-0">
            <p className="transcript fw-bold  primary_color">
              {tForLang("course_modules_transcript")}{" "}
            </p>
            <div className="module-content">
              {paragraphs.map((text, idx) => (
                <div className="  shadow-right-left" key={idx}>
                  <div className="card-body px-0">
                    <p className="mb-0" style={{ fontSize: "16px" }}>
                      <div className="d-flex align-items-start" dangerouslySetInnerHTML={{ __html: text }} />
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Video;
